import { GeoLocationService } from './../../../../services/geo-location/geo-location.service';
import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { AuthService } from 'src/app/services/auth.service';
import { MapServiceService } from '../../services/Map-service/map-service.service';
import { SideNavService } from '../../services/sidenav/side-nav.service';
import { ErrorInternetConnectionService } from 'src/app/services/CheckInternetConnection/error-internet-connection.service';
import { MapNotAvailableModalComponent } from '../../modals/map-not-available-modal/map-not-available-modal.component';
import { GlobalService } from 'src/app/services/global.service';
import { PlatformLocation } from '@angular/common';
import { Projection, fromLonLat, transform } from 'ol/proj';
import { HttpClient } from '@angular/common/http';
declare const google: any;
@Component({
  selector: 'app-map-layout',
  templateUrl: './map-layout.component.html',
  styleUrls: ['./map-layout.component.css'],
})
export class MapLayoutComponent implements OnInit, AfterViewChecked {
  time: any;
  startTimer = false;
  //for chat
  chatEnable: any = true;
  showChat: any;
  chatBtnText: any;
  chatImageUrl: any;
  showEplan: any;
  baseMaps: any;
  state = 'closed';
  leftState: any;
  boundaries: any;
  path: any;
  infoBar = false;
  loadMap = false;
  defaultView: any = false;
  share: any;
  infoLeftState: any;
  zoom: any;
  minZoom: any;
  collaboratorId: any;
  id: any;
  userType: any;
  favIcon: any;
  zoomValue: any;
  tools: any;
  showLegend: any;
  mapId: any;
  mapName: any;
  embedHide = 'false';
  mySharedMaps: any;
  hideEnplanChat: any;
  hideHeader: any;
  rightEnplan: any = 5;
  rightClose: any;
  position: any
  constructor(
    public activatedRoute: ActivatedRoute,
    public mapServices: MapServiceService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public sideNavService: SideNavService,
    private titleService: Title,
    public auth: AuthService,
    public router: Router,
    private cdr: ChangeDetectorRef,
    public internetConnectionService: ErrorInternetConnectionService,
    private global: GlobalService,
    public location: PlatformLocation
    ) {
    this.path = this.activatedRoute.snapshot.params['map'];
    this.mapServices.Mapslug = this.path;
    const id = ''
    this.mapServices.dynamicMapModalCheck()
  }

  ngOnInit(): void {
    this.mapServices.hideHeader.subscribe((res: any) => {
      this.defaultView = res;
    });
    this.sideNavService.showChat.subscribe((res) => {
      this.showChat = res;
    });
    setTimeout(() => {
      this.embedHide = this.mapServices.embed;
    }, 1000);
    if (this.mapServices.embed) {
      window.history.pushState(null, '', window.location.href);
      window.onpopstate = function () {
        window.history.pushState(null, '', window.location.href);
      };
    }
    const data = localStorage.getItem('collId');
    this.mapServices.collId = data;
    const colType = localStorage.getItem('coltype');
    this.collaboratorId = data;
    // let decide: any;
    if (
      (this.auth.user && this.auth.user.type === 'collaborate') ||
      colType === 'collaborate'
    ) {
      this.startTimer = true;
      this.resetTimer();
      this.userType = 'false';
      this.id = data;
    }

    this.mapServices.shareId = this.route.snapshot.queryParams['share'];
    if (!this.mapServices.shareId) {
      this.mapServices.shareId = '';
    } else {
      this.mapServices.shareId;
    }

    if (localStorage.getItem('shared') === 'true') {
      this.userType = 'false';
      this.id = data;
      let currentUrl = this.router.url;
      currentUrl = currentUrl.replace('/', '');

      if (currentUrl !== localStorage.getItem('mapName')) {
        localStorage.removeItem('shared');
        localStorage.removeItem('mapName');
        this.userType = 'true';
        this.id = '';
      }
    } else {
      this.userType = 'true';
      this.id = '';
    }

    if (!this.id) {
      this.id = '';
    }
    this.mapAccess();
    this.mapServices.currentZoom.subscribe((res) => {
      this.zoom = res;
    });
    this.sideNavService.samePanelSize.subscribe((value: any) => {
      this.showEplan = value;
    });

    this.state = 'closed';
    this.sideNavService.openCloseSideNav.subscribe((res: any) => {
      this.state = res;
      if (this.state !== 'closed') {
        if (!this.defaultView) {
          const fontSize = localStorage.getItem('fontSize');
          switch (fontSize as any) {
            case '11':
              this.rightEnplan = 215;
              break;
            case '12':
              this.rightEnplan = 215;
              break;
            case '14':
              if (!this.showEplan) {
                this.rightEnplan = 215;
              } else {
                this.rightEnplan = 254;
              }
              break;
            case '16':
              if (!this.showEplan) {
                this.rightEnplan = 215;
              } else {
                this.rightEnplan = 310;
              }

              break;
            default:
              this.rightEnplan = 215;
          }
        } else {
          this.rightEnplan = 5;
        }
      } else {
        this.rightEnplan = 5;
      }
      this.infoBar = false;
    });
    // this.leftState = 'open'
    this.sideNavService.leftSideNav.subscribe((res: any) => {
      this.leftState = res;
    });
    this.sideNavService.infoSidebar.subscribe((res: any) => {
      this.infoLeftState = res;
      this.infoBar = true;
    });

    setTimeout(() => {
      this.mapServices.hideHeader.subscribe((res: any) => {
        this.hideHeader = res;
      });
    }, 100);
  }
  preventBack() {
    window.history.forward();
  }
  mapAccess(): void {
    this.mapServices
      .getMapData(
        this.path,
        this.userType,
        this.mapServices.shareId,
        this.id.toString()
      )
      .subscribe(
        (res) => {
          if (res.status !== 404) {
            if (res.map_data.interface.map_type == 'wv-map') {
              this.global.loadGoogleAnalytics('UA-97225393-4');
            } else if (res.map_data.interface.map_type == 'pv-map') {
              this.global.loadGoogleAnalytics('UA-97225393-3');
            }
            if (res?.map_data?.subscription_ending_date) {
              this.auth.expiryMap = res?.map_data?.subscription_ending_date;
            }

            this.mapServices.setIcon(res.map_data.interface.map_logo_url);
            //for elements visiblilty
            this.mapServices.elementsVisibility =
              res.map_data.map_data.elements;
            this.chatEnable = this.mapServices.elementsVisibility['chat'];
            this.chatBtnText = res.map_data.map_data.chat_button_text || 'None';
            this.chatImageUrl = res.map_data.map_data.chat_button_image_url;
            this.sideNavService.searchLimit = res.map_data.search_limit;
            this.mapServices.chat_display_message =
              res.map_data.map_data.chat_display_message;
            //wildfire damage viewer is blocked as per client modificition and check is added
            this.mapServices.mapAccessLevel = res.map_access_level;
            if (
              res.map_assessible == true &&
              res.map_data.interface.map_type !== 'fdp-map'
            ) {
              this.mapServices.mapData = res;
              this.mapId = this.mapServices.mapData.map_data.map_data.id;
              this.mapName = this.mapServices.mapData.map_data.map_data.name;
              this.mapServices.shareData =
                this.mapServices.mapData.map_data.share;
              if (
                this.mapServices.shareData.live_share &&
                !this.mapServices.shareData.expire
              ) {
                this.mapServices.bookMarkTool = true;
                this.mapServices.shareData.basic_data;
              }
              const originUrl = location.origin;
              const href = this.router.url;
              this.mapServices.pageUrl = originUrl.concat(href);
              this.mapServices.mapInterface = res.map_data.interface;
              this.mapServices.templatetoolTips =
                res.map_data.map_data.tools_tips;

              this.tools = res.map_data.map_data.tools;
              if (
                this.tools.left_panel &&
                res.map_data.share.live_share == false
              ) {
                this.showLegend = true;
              } else if (
                this.tools.left_panel &&
                res.map_data.share.show_legend == true
              ) {
                this.showLegend = true;
              }
              this.titleService.setTitle(
                this.mapServices.mapInterface.page_title
              );
              this.mapServices.accessMapApi = res;
              this.loadMap = true;
              setTimeout(() => {
                this.sideNavService.loadfirst(true);
              }, 1000);
            } else {
              if (res.map_data.interface.map_type !== 'fdp-map') {
                this.mapServices.mapData = res;
                this.mapId = this.mapServices.mapData.map_data.map_data.id;
                this.mapName = this.mapServices.mapData.map_data.map_data.name;
                this.mapServices.mapInterface = res.map_data.interface;
                this.mapServices.shareData =
                  this.mapServices.mapData.map_data.share;
                const originUrl = location.origin;
                const href = this.router.url;
                this.mapServices.pageUrl = originUrl.concat(href);

                this.titleService.setTitle(
                  this.mapServices.mapInterface.page_title
                );
                this.mapServices.accessMapApi = res;
                this.loadMap = true;
                setTimeout(() => {
                  this.sideNavService.loadfirst(true);
                }, 1000);

                if (this.mapServices.mapInterface.map_type == 'wv-map') {
                  // this.dialog.open(WelcomeWildfireComponent, {
                  //   disableClose: true,
                  //   backdropClass: 'bdropDark1',
                  // });

                  this.startTimer = false;
                  clearTimeout(this.time);
                  this.router.navigate(['login']);
                }
                if (this.mapServices.mapInterface.map_type == 'pv-map') {
                  // this.dialog.open(WelcomeParcelComponent, {
                  //   disableClose: true,
                  //   backdropClass: 'bdropDark1',
                  //   autoFocus: false,
                  //   //you can adjust the value as per your view
                  //   maxHeight: '85vh',
                  // });
                  this.startTimer = false;
                  clearTimeout(this.time);
                  this.router.navigate(['login']);
                }
                //block as per client requirement
                // if (this.mapServices.mapInterface.map_type == 'fdp-map') {
                //   this.dialog.open(WelcomeWildfireDamageComponent, {
                //     disableClose: true,
                //     backdropClass: 'bdropDark1',
                //   });
                // }
                if (this.mapServices.mapInterface.map_type == 'custom-map') {
                  // this.dialog.open(WelcomeCustomComponent, {
                  //   disableClose: true,
                  //   backdropClass: 'bdropDark1',
                  // });
                  this.startTimer = false;
                  clearTimeout(this.time);
                  this.router.navigate(['login']);
                }
              }
            }
          } else {
            this.dialog.open(MapNotAvailableModalComponent, {
              position: {
                top: '20%',
              },
              data: {
                title: res.error.title,
                message: res.error.message,
              },
            });
          }
        },
        () => {
          //
        }
      );
  }
  ngAfterViewChecked() {
    //your code to update the model
    this.cdr.detectChanges();
  }

  @HostListener('window:keydown.control', ['$event'])
  onkeydown($event: KeyboardEvent) {
    if ($event.ctrlKey) {
      console.log($event.ctrlKey)
      this.sideNavService.ctrlCheckButton(true);
      this.mapServices.ctrlCheck = true;
    }
  }
  @HostListener('window:keyup.control', ['$event'])
  onkeyup() {
    console.log('false')
    this.sideNavService.ctrlCheckButton(false);
    this.mapServices.ctrlCheck = false;
  }

  //for showing chat
  showChatNow(): void {
    this.showChat = true;
  }
  openEnplan() {
    window.open('http://www.enplan.com', '_blank');
  }

  @HostListener('document:mousemove')
  @HostListener('document:keypress')
  @HostListener('document:click')
  @HostListener('document:wheel')
  resetTimer() {
    clearTimeout(this.time);
    if (this.startTimer) {
      this.time = setTimeout(() => {
        this.startTimer = false;
        clearTimeout(this.time);
        this.router.navigate(['login']);
      }, 3600000);
      //currently set time to 10 min for testing (10 mins * 60 seconds per minute * 1000 milliseconds per second.)
    }
  }
}
